import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const CornerDegreeIcon = (props?: SvgProps) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#B0B2B6"
      {...props}
    >
      <title>{props?.title}</title>

      <path d="M0.999863 0V15.0003H15.0001" strokeWidth="1.50003" />
      <path
        d="M7.00009 15.0005C6.88425 11.7821 4.50004 9.06254 0.999969 10.0004"
        strokeWidth="1.50003"
      />
    </svg>
  )
}
